import React from 'react';

// GLOBAL FUNCTIONS
import { formatDate } from 'functions.js';

// CORE COMPONENTS
import Form from 'core/form/Form';

// LOCAL COMPONENTS
import FormWrapper from '../parts/FormWrapper';

// VARIABLES
const INITIAL_VALUES = {
  input: 'Text goes here',
  date: formatDate(new Date(), 4, true),
  select: 2,
  custom_select: 'Custom Value',
  check_list: [1, 3],
  radio_list: 2,
  text_area: 'Lorem ipsum dolor sit amet...'
}

// MAIN COMPONENT
const FormElements = () => (
  <FormWrapper
    initialValues={INITIAL_VALUES}
    inline={<>
      <Form.Label>Inline Form</Form.Label>
      <Form.Control
        name="input1"
        placeholder="Type Here"
        required
      />
      <Form.Group>
        <Form.Control
          name="input2"
          placeholder="Type Here"
          required
        />
        <Form.Select
          name="select"
          options={[
            {
              label: 'Option One',
              value: 1
            },
            {
              label: 'Option Two',
              value: 2
            },
            {
              label: 'Option Three',
              value: 3
            },
          ]}
          useNone
          required
        />
      </Form.Group>
      <Form.Date
        name="date"
        useOptions
        range
      />
      <Form.Checklist
        name="checkbox"
        options={[
          {
            label: 'Check Here',
            value: 1
          }
        ]}
      />
    </>}
  >
    <Form.Control
      name="input"
      label="Text Input"
      required
    />
    <Form.Control
      name="dollar"
      label="Dollar Input"
      schema="dollars"
      required
    />
    <Form.Textarea
      name="text_area"
      label="Text Area"
      required
    />
    <Form.Select
      name="select"
      label="Select"
      options={[
        {
          label: 'Option One',
          value: 1
        },
        {
          label: 'Option Two',
          value: 2
        },
        {
          label: 'Option Three',
          value: 3
        },
      ]}
      useNone
      required
    />
    <Form.Select
      name="custom_select"
      label="Custom Select"
      options={[
        {
          label: 'Option One',
          value: 1
        },
        {
          label: 'Option Two',
          value: 2
        },
        {
          label: 'Option Three',
          value: 3
        },
      ]}
      filterOptions
      required
    />
    <Form.Checklist
      name="check_box"
      label="Check Box"
      options={[
        {
          label: 'Check Here',
          value: 1
        }
      ]}
    />
    <Form.YesNo
      name="yes_no"
      label="Yes/No"
    />
    <Form.Checklist
      name="check_list"
      label="Check List"
      options={[
        {
          label: 'Option One',
          value: 1
        },
        {
          label: 'Option Two',
          value: 2
        },
        {
          label: 'Option Three',
          value: 3
        },
      ]}
      required
    />
    <Form.Checklist
      name="radio_list"
      label="Radio Buttons"
      type="radio"
      options={[
        {
          label: 'Option One',
          value: 1
        },
        {
          label: 'Option Two',
          value: 2
        },
        {
          label: 'Option Three',
          value: 3
        },
      ]}
      required
    />
    <Form.Date
      name="date"
      label="Date"
      required
    />
    <Form.Date
      name="date_options"
      label="Date (with options)"
      useOptions
    />
    <Form.Date
      name="manual_date_range"
      label="Date Range"
      range
    />
    <Form.Date
      name="date_range"
      label="Date Range (with options)"
      range
      useOptions
    />
    <Form.Date
      name={['start_date', 'end_date']}
      label="Date Range (with separate values)"
      useOptions
    />
  </FormWrapper>
)

// EXPORT
export default FormElements;
